    export const results = {
    type1: {
        id: 1,
        title: "🎢 롤러코스터형",
        subtitle: "체력은 국대급, 텐션은 롤러코스터",
        description: "밤이 되면 더 살아나는 사람! 지루할 틈 없이 도파민이 터지는 여행을 사랑해요.",
        recommend: "🇺🇸 뉴욕 타임스퀘어, 🇯🇵 오사카 도톤보리, 🇹🇭 방콕 카오산로드, 🇲🇽 멕시코시티, 🇳🇱 암스테르담, 🇰🇷 부산 서면"
    },
    type2: {
        id: 2,
        title: "🔥 올인형",
        subtitle: "왔으면 다 보고 간다",
        description: "밀도 높은 일정이 취향! 랜드마크는 싹 다 돌아야 직성이 풀리는 열정 만수르.",
        recommend: "🇫🇷 파리 핵심 투어, 🇮🇹 로마+피렌체, 🇬🇧 런던 시내 완주, 🇹🇷 이스탄불, 🇸🇬 싱가포르 시티, 🇯🇵 도쿄 랜드마크"
    },
    type3: {
        id: 3,
        title: "⚡ 충전형",
        subtitle: "사람 많은 곳에서 배터리 100%",
        description: "도시의 소음과 화려한 네온사인 속에서 오히려 에너지를 풀충전하는 타입이에요.",
        recommend: "🇺🇸 뉴욕 맨해튼, 🇯🇵 도쿄 시부야, 🇰🇷 서울 홍대·성수, 🇭🇰 홍콩 침사추이, 🇪🇸 마드리드, 🇧🇷 리우데자네이루"
    },
    type4: {
        id: 4,
        title: "🧭 방랑형",
        subtitle: "길을 잃어야 진짜 여행",
        description: "계획보다는 우연을 사랑해요. 낯선 골목길을 누비며 현지 바이브를 느끼는 낭만파!",
        recommend: "🇵🇹 리스본 구시가지, 🇻🇳 호이안, 🇮🇹 베네치아 골목, 🇲🇦 마라케시, 🇪🇸 세비야, 🇬🇷 아테네 플라카"
    },
    type5: {
        id: 5,
        title: "🌿 리셋형",
        subtitle: "비워야 다시 채워진다",
        description: "탁 트인 자연 속에서 심신을 회복해요. 맑은 공기와 풍경만 있으면 완벽한 여행이죠.",
        recommend: "🇳🇿 뉴질랜드 퀸스타운, 🇨🇭 인터라켄, 🇰🇷 제주 오름, 🇮🇸 아이슬란드 링로드, 🇨🇦 로키 산맥 밴프, 🇮🇩 발리 우붓"
    },
    type6: {
        id: 6,
        title: "☁️ 고요형",
        subtitle: "소리보다 온도를 느낀다",
        description: "시각적 자극보다는 고요한 온도와 분위기를 사랑하는 평화주의자입니다.",
        recommend: "🇯🇵 교토 외곽, 🇳🇴 노르웨이 피오르드, 🇨🇭 루체른, 🇫🇮 핀란드 로바니에미, 🇩🇰 코펜하겐, 🇨🇦 빅토리아"
    },
    type7: {
        id: 7,
        title: "☕ 공간음미형",
        subtitle: "한 장소를 깊게 즐긴다",
        description: "여기저기 바쁘게 다니기보단, 마음에 드는 카페나 공간 하나에 머무는 걸 좋아해요.",
        recommend: "🇫🇷 몽마르트, 🇵🇹 포르투, 🇰🇷 전주 한옥마을, 🇮🇹 피렌체 올트라노, 🇯🇵 교토 카페 거리, 🇪🇸 그라나다 알바이신"
    },
    type8: {
        id: 8,
        title: "🛌 숙소중심형",
        subtitle: "숙소가 여행의 절반",
        description: "숙소 밖은 위험해! 좋은 숙소를 예약해 두고 그 안에서 모든 걸 해결하는 궁극의 힐링러.",
        recommend: "🇲🇻 몰디브 리조트, 🇬🇷 산토리니 풀빌라, 🇨🇭 알프스 샬레, 🇯🇵 홋카이도 료칸, 🇮🇹 코모 호수 빌라, 🇦🇺 그레이트 오션로드 독채"
    }
    };